import styled from 'styled-components';

import { AnimationSlideInFromBottom } from '../../styles/AnimationSlideInFromBottom';

export const Container = styled.div`

    & {
        ${AnimationSlideInFromBottom}
    }

`;
